import { getP } from 'redux-polyglot'
import api from '../libs/api'
import auth from '../libs/auth'
import { clearCartReference } from '../libs/helpers'
import { showToast } from './app'

/**
 * Actions for performing the logout
 */
export const LOGOUT_REQUEST = 'AUTH/LOGOUT/REQUEST'
export const LOGOUT_SUCCESS = 'AUTH/LOGOUT/SUCCESS'
export const LOGOUT_FAILURE = 'AUTH/LOGOUT/FAILURE'

const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
})

export const logoutSuccess = () => {
  auth.logout()
  return {
    type: LOGOUT_SUCCESS,
  }
}

const logoutFailure = error => ({
  type: LOGOUT_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const logout = () => (dispatch, getState) => {
  clearCartReference()
  dispatch(logoutRequest())
  return api
    .notifyLogout()
    .then(res => res.json())
    .then(
      () =>
        Promise.all([
          dispatch(
            showToast(
              getP(getState()).t('tv_auth.logged_out_success', {
                _: 'Successfully logged out',
              })
            )
          ),
          dispatch(logoutSuccess()),
        ]),
      () => {
        const errorMessage = getP(getState()).t('tv_auth.error_logging_out', {
          _: 'An error occurred while logging you out',
        })
        return Promise.all([
          dispatch(logoutFailure(errorMessage)),
          dispatch(showToast(errorMessage, 'error')),
        ])
      }
    )
}
